import { useDispatch, useSelector } from 'react-redux';
import { FORM_TYPE_CREATE_ELT } from 'js/constants/formTypes';
import { useCallback, useMemo } from 'react';
import { updateFormData as updateFormDataAction } from 'js/actions';
import useFlowsSetup from 'new/components/flows/controller/useFlowsSetup';
import flowTypes from 'new/components/flows/types/flowTypes';
import usePaging from 'new/state/paging/repository/usePaging';
import { createResourceSetupService } from 'new/components/flows/configure/ELT/ELTSourceSetup/service/createResourceSetupService';

export default function useELT(): {
  updateFormData: (data: any) => void;
  updateELTResourceConfig: (data: any) => void;
  [key: string]: any;
} {
  const dispatch = useDispatch();

  const service = createResourceSetupService();

  const paging = usePaging();

  const { data, onSelectConnection, updateFormData, resetFormData } = useFlowsSetup(
    FORM_TYPE_CREATE_ELT,
    flowTypes.elt,
  );

  const updateELTResourceConfig = useCallback(
    (resourceConfig) => {
      dispatch(
        updateFormDataAction(FORM_TYPE_CREATE_ELT, {
          resourceConfig: {
            ...data?.resourceConfig,
            ...resourceConfig,
          },
        }),
      );
    },
    [dispatch, data],
  );

  const selectedConnection = data?.selectedConnection;

  const connectionCategory = paging.getConnectionCategoryByConnectorType(selectedConnection);

  return useMemo(() => {
    return {
      ...data,
      data,
      connectionCategory,
      updateFormData,
      resetFormData,
      allowCustomPrefixEditor: service.canEditPrefix({
        connectionCategory,
        selectedBucket: data?.selectedBucket,
        sinkConfig: data?.sinkConfig,
      }),
      onSelectConnection: onSelectConnection(flowTypes.elt),
      updateELTResourceConfig,
    };
  }, [data, updateFormData, updateELTResourceConfig, connectionCategory]);
}
